import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { TooltipDirective } from './tooltip.directive';

@NgModule({
    declarations: [TooltipComponent, TooltipDirective],
    imports: [CommonModule],
    entryComponents: [TooltipComponent],
    exports: [TooltipComponent, TooltipDirective],
})
export class TooltipModule {}
